import { Component, Input } from '@angular/core';
import { MssLayerViewDetails } from 'private/app/models/user.model';

@Component({
    selector: 'hvac-layer-view-mss-data',
    templateUrl: './layer-view-mss-data.component.html',
    styleUrls: ['./layer-view-mss-data.component.scss']
})
export class LayerViewMssDataComponent {
    @Input() mssData: MssLayerViewDetails[];

    public isRolesExpanded: boolean = false;
    public isFeaturesExpanded: boolean = false;

    public toggleRolesAccordion() {
        this.isRolesExpanded = !this.isRolesExpanded;
    }

    public toggleFeaturesAccordion() {
        this.isFeaturesExpanded = !this.isFeaturesExpanded;
    }
}
